import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '@/components/SectionTitle';
import Seo from '@/seo/Seo';
import { PAGE_SEO } from '@/seo/seoConfig';
import { breadcrumbSchema } from '@/seo/schemas';
import { Heart, Globe, Users, Megaphone, HandHeart } from 'lucide-react';

export default function Evangelism() {
  return (
    <div>
      <Seo
        title={PAGE_SEO.evangelism.title}
        titleExact
        description={PAGE_SEO.evangelism.description}
        keywords={PAGE_SEO.evangelism.keywords}
        path="/services/evangelism"
        jsonLd={[breadcrumbSchema([
          { name: 'Home', path: '/' },
          { name: 'Services', path: '/services' },
          { name: 'Evangelism', path: '/services/evangelism' },
        ])]}
      />
      <section className="gradient-purple text-white py-12 sm:py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <Link to="/services" className="text-moj-gold text-sm hover:underline">← Back to all services</Link>
          <h1 className="font-serif text-4xl sm:text-5xl text-white mt-3 mb-3">Evangelism</h1>
          <p className="text-lg text-white/90 max-w-3xl">Evangelism ministry carries the message of Jesus Christ into the local community through prayer, testimony, compassion, invitation, and practical service.</p>
        </div>
      </section>

      <section className="py-16 bg-moj-cream">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 grid md:grid-cols-2 gap-8">
          {[
            { icon: Globe, title: 'Local Outreach', text: 'Street prayer, gospel conversations, door-to-door invitations and community events across Dublin.' },
            { icon: Megaphone, title: 'Testimony Sharing', text: 'Believers sharing their stories of redemption — because the testimony of Jesus is the spirit of prophecy.' },
            { icon: HandHeart, title: 'Community Service', text: 'Meeting practical needs in Jesus’ Name — food, clothing, friendship, hospitality.' },
            { icon: Heart, title: 'Compassion Ministry', text: 'Visiting the sick, the elderly and the lonely; carrying hope where there has been none.' },
          ].map((c) => (
            <div key={c.title} className="card-moj p-7">
              <c.icon size={32} className="text-moj-gold-deep mb-3"/>
              <h3 className="font-serif text-xl mb-2">{c.title}</h3>
              <p className="text-moj-charcoal/80">{c.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 gradient-purple text-white text-center">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <Users size={48} className="text-moj-gold mx-auto mb-4"/>
          <h2 className="font-serif text-3xl text-white mb-3">Step out with us</h2>
          <p className="text-white/90 mb-6">Volunteer with our Evangelism team and let’s carry the gospel into Ireland together.</p>
          <Link to="/contact" className="btn-gold"><HandHeart size={16}/> Volunteer Today</Link>
        </div>
      </section>
    </div>
  );
}
